/* eslint-disable node/no-unsupported-features/es-syntax */

'use strict';

/*
  TODO: consider lazyloading all of this JS
  in modal_cluster bundle
*/

const { windowLoaded } = require('@grpn/document-states');
const removeUrgencyPricing = require('../util/remove_urgency_pricing');

const syncOptions = function ({ isInline, isOverlay, optionUuid }) {
  const $modal = document.querySelector('#options');

  if (!$modal) {
    return;
  }

  if (isInline) {
    $modal.querySelector(
      `.multi-option-overlay-list input[data-uuid='${optionUuid}']`
    ).checked = true;
  } else if (isOverlay) {
    const $inlineOption = document.querySelector(
      `.m-option-b.inline-list input[data-uuid='${optionUuid}']`
    );
    $inlineOption.checked = true;

    const $inlineListElement = $inlineOption.parentNode.parentNode;
    if ($inlineListElement.classList.contains('hide')) {
      const $inlineList = $inlineListElement.parentNode;
      $inlineList.insertAdjacentElement('afterbegin', $inlineListElement);
      [...$inlineList.querySelectorAll('li')]
        .filter(el => !el.classList.contains('hide'))
        .pop()
        .classList.add('hide');
      $inlineListElement.classList.remove('hide');
    }
  }
};

const addScrollOverlayListener = function () {
  const $overlay = document.querySelector('#options .scroll-fade-overlay');
  if ($overlay) {
    const observer = new window.IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio >= 0.75) {
            $overlay.style.display = 'none';
          } else {
            $overlay.style.display = 'block';
          }
        });
      },
      {
        threshold: 0.75,
      }
    );

    observer.observe(
      [...document.querySelectorAll('.m-option-b.option-list li')].pop()
    );
  }
};

const importModalClusterJS = function () {
  return import(/* webpackChunkName: "modal_cluster" */ './modal_cluster').then(
    modalCluster => {
      if (document.querySelector('#options').classList.contains('show-modal')) {
        modalCluster.init(this.data);
      } else {
        document.querySelector('#view-options a').addEventListener(
          'click',
          () => {
            modalCluster.init(this.data);
          },
          {
            once: true,
          }
        );
      }
    }
  );
};

module.exports = function () {
  const $openModalButton = document.querySelector('#view-options a');
  if ($openModalButton) {
    $openModalButton.addEventListener('click', addScrollOverlayListener);
    if (this.data.enabled) {
      windowLoaded.then(() => importModalClusterJS.call(this));
    }
  }
  this.eventPipe.on('option_updated', syncOptions);

  window.DealEventPipe.on('juice_price_ended', () => {
    removeUrgencyPricing(this.data);
  });
};
